import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Constants } from '../constants/constants';
import { ApiService } from '../service/api.service';
import { UtilService } from '../service/util.service';
import { ToastService } from '../service/toast.service';
import { AuthenticationService } from '../service/authentication.service';
import { MessageConstants } from '../constants/message-constants';
import { EnvService } from '../service/env.service';

@Component({
  selector: 'user-tnc',
  templateUrl: './user-tnc.component.html',
  styleUrls: ['./user-tnc.component.scss']
})
export class UserTncComponent implements OnInit {

  tnc: any = {
    "id": null,
    "name": null,
    "description": null,
    "url": null,
    "version": null,
    "effectiveDate": null,
    "active": null,
    "enterpriseId": null,
    "appType": null,
  };

  isUserTnCAccepted: boolean = false;
  mimeType = "application/pdf";

  @Output() userTnCAccepted: EventEmitter<any> = new EventEmitter<any>();

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService, private env: EnvService) { }

  ngOnInit() {
    /* let accountStatus = this.apiService.accountDetail.status;

    // DONOT remove this code, when Tnc in Place we need this
    if (accountStatus == Constants.INACTIVE || accountStatus == Constants.PENDING) {
      // document.getElementById("openUserTnc").click();
      this.getUserTnc();
    } */
  }

  init() {
    this.resetUserTncModel();
    this.getUserTnc();
  }

  initTncModel(data) {
    this.tnc.id = data && data.id ? data.id : null;
    this.tnc.name = data && data.name ? data.name : null;
    this.tnc.description = data && data.description ? data.description : null;
    this.tnc.url = data && data.url ? data.url : null;
    this.tnc.version = data && data.version ? data.version : null;
    this.tnc.effectiveDate = data && data.effectiveDate ? data.effectiveDate : null;
    this.tnc.active = data && data.active ? data.active : null;
    this.tnc.enterpriseId = data && data.enterpriseId ? data.enterpriseId : null;
    this.tnc.appType = data && data.appType ? data.appType : null;
  }

  getUserTnc() {
    this.utilService.showSpinner();

    this.apiService.getUserTnc(this.env.PORTAL_APP_TYPE.get(this.env.MODE)).then((data) => {
      this.utilService.hideSpinner();
      console.log("User TnC data::", data);
      if (data == null) {
        this.userTnCAccepted.emit();
      } else {
        // this.initTncModel(data);  
        this.tnc=data;
        document.getElementById("openUserTnc").click();
      }
    }).catch((error) => {
      console.log("err : ", error);

      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          this.getUserTnc();
        });
      } else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message)
          this.toast.showError(error.error.message);
        else
          this.toast.showError(Constants.UNKNOWN_ERROR);

        setTimeout(() => {
          this.resetUserTncModel();
          this.authService.logout();
        }, 500);
      }

    });
  }
  /* getUserTnc() {
    this.utilService.showSpinner();

    this.apiService.getUserTnc(this.getAppType()).then((data) => {
      this.utilService.hideSpinner();

      this.initTncModel(data);

      if (data != null) {
        document.getElementById("openUserTnc").click();
      }

      console.log("User TnC data::", this.tnc);

    }).catch((error) => {
      console.log("err : ", error);

      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getUserTnc();
        });
      } else if (error.status == Constants.HTTP_NOT_FOUND) {
        this.utilService.hideSpinner();
        console.log(MessageConstants.TNC_NOT_SET);
        // this.authService.logout();
        this.userTnCAccepted.emit();
      } else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
        this.authService.logout();
      }

    });
  } */

  acceptUserTnC() {

    if (!this.isUserTnCAccepted) return;
    this.utilService.showSpinner();
    this.apiService.acceptUserTnC(this.tnc.id).then((data) => {
      // this.apiService.accountDetail.status = Constants.ENABLED;
      this.utilService.hideSpinner();
      // this.authService.checkToken();
      this.userTnCAccepted.emit();
      document.getElementById("closeUserTnc").click();
      console.log("TnC accept data::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.acceptUserTnC();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }

      document.getElementById("closeUserTnc").click();
      this.resetUserTncModel();
      this.authService.logout();

      /* setTimeout(() => {
        document.getElementById("closeUserTnc").click();
        this.resetUserTncModel();
        this.authService.logout();
      }, 500); */

    });
  }

  resetUserTncModel() {
    this.tnc = {
      "id": null,
      "name": null,
      "description": null,
      "url": null,
      "version": null,
      "effectiveDate": null,
      "active": null,
      "enterpriseId": null,
      "appType": null,
    };

    this.isUserTnCAccepted = false;
  }

  acceptTnc() {
    // var payload = null;
    // this.acceptUserTnC(payload);
    this.acceptUserTnC();
  }
  
  getTncData() {
    console.log("mime type::", this.mimeType);
    this.utilService.showSpinner();
    this.apiService.downloadPdf(this.tnc.url).then((data) => {
      console.log("data: ", data);
      this.showTncData(data, this.mimeType);
      this.utilService.hideSpinner();
    }).catch((error) => {
      console.log("err : ", error);
      if (error && error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getTncData();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  showTncData(data, mimeType) {
    var blob = new Blob([data], {type: mimeType});
    var downloadURL = window.URL.createObjectURL(blob);
    window.open(downloadURL, '_blank');
  }

}
